<div class="card border-0 overflow-y-auto h-100 pe-2">
  <div class="card-body p-3">
    <h2 class="fw-600 mb-1 d-flex align-items-center gap-2">
      <span class="text-gray-400">#{{ selectedTask().sequence }}</span
      >{{ selectedTask().taskName }}
    </h2>

    @if (selectedTask().predecessorName) {
      <div class="d-flex align-items-center gap-2 mb-3">
        <i class="bi bi-arrow-return-right"></i>
        <span class="d-block"> {{ selectedTask().predecessorName }} </span>
      </div>
    }

    <div class="d-flex justify-content-between align-items-center">
      <h6 class="d-block fw-600 mb-2">Project Details</h6>
      <button class="btn btn-primary btn-h42" (click)="openScheduleVpoModal()">
        <i class="bi bi-plus fs-20"></i>
        VPO
      </button>
    </div>
    <p class="text-black mb-0">
      <span class="fw-500 me-1">Project:</span>
      <app-project-info-popup [projectId]="selectedTask().projectId">
        <span class="text-primary text-decoration-underline">
          {{ selectedTask().projectName }}
        </span>
      </app-project-info-popup>
    </p>
    <p class="text-black mb-0">
      <span class="fw-500 me-1">Lot:</span>
      <app-lot-info-popup [lotId]="selectedTask().lotId">
        <span class="text-primary text-decoration-underline">
          {{ selectedTask().lotNo }}
        </span>
      </app-lot-info-popup>
    </p>

    <hr />

    <h6 class="d-block fw-600 mb-2">Task Details</h6>
    <div class="row">
      <div class="col-6">
        <p class="mb-1">
          <span class="fw-500">Milestone:</span>
          {{ selectedTask().milestone ? 'Yes' : 'No' }}
        </p>
        <p class="mb-0"><span class="fw-500">Float Day:</span> {{ selectedTask().floatDay }}</p>
      </div>
      <div class="col-6">
        <p class="mb-1"><span class="fw-500">Duration:</span> {{ selectedTask().duration }}</p>
        <p class="mb-0"><span class="fw-500">Stage Name:</span> {{ selectedTask().stageName }}</p>
      </div>
    </div>
    <hr />

    @if (selectedTask().status || selectedTask().completedDate) {
      <h6 class="d-block fw-600 mb-2">Task Status</h6>
      <div class="row">
        @if (selectedTask().status) {
          <div class="col-6">
            <p class="mb-1">
              <span class="fw-500">Status:</span>
              {{ selectedTask().status }}
            </p>
          </div>
        }
        @if (selectedTask().completedDate) {
          <div class="col-6">
            <p class="mb-1">
              <span class="fw-500">Completion Date:</span>
              {{ selectedTask().completedDate | date: 'MMM d, y' }}
            </p>
          </div>
        }
      </div>
      <hr />
    }

    <h6 class="d-block fw-600 mb-2">Dates</h6>

    <!-- Planned Dates -->
    <div class="d-flex gap-3 mb-3">
      <i class="bi bi-pencil mt-1"></i>
      <div>
        <span class="d-block fw-500 text-black-50 text-nowrap">Planned dates</span>
        <span class="fs-16 fw-500 text-nowrap"
          >{{ selectedTask().plannedStartDate | date: 'MMM d, y' }} -
          {{ selectedTask().plannedEndDate | date: 'MMM d, y' }}</span
        >
      </div>
    </div>

    <!-- Revised Dates -->
    <div class="d-flex gap-3 mb-3">
      <i class="bi bi-calendar2-minus mt-1"></i>
      <div>
        <span class="d-block fw-500 text-black-50 text-nowrap">Revised Dates</span>
        <span class="fs-16 fw-500"
          >{{ selectedTask().revisedStartDate | date: 'MMM d, y' }} -
          {{ selectedTask().revisedEndDate | date: 'MMM d, y' }}</span
        >
      </div>
    </div>

    <!-- Actual Dates -->
    <div class="d-flex gap-3 mb-1">
      <i class="bi bi-calendar-minus mt-1"></i>
      <div>
        <span class="d-block fw-500 text-black-50 text-nowrap">Actual Dates</span>
        @if (selectedTask().actualStartDate || selectedTask().actualEndDate) {
          <span class="fs-16 fw-500"
            >{{ selectedTask().actualStartDate | date: 'MMM d, y' }}
            @if (selectedTask().actualEndDate) {
              -
            }
            {{ selectedTask().actualEndDate | date: 'MMM d, y' }}</span
          >
        }
        @if (ability.can('update-schedule-lots-tasks', 'schedule-lots')) {
          <div class="row g-2 mt-0">
            <div class="col-6">
              <label class="form-label" for="">Start Date</label>
              <p-datepicker
                styleClass="w-100"
                [iconDisplay]="'input'"
                [showIcon]="true"
                [ngModel]="actualStartDate()"
                (ngModelChange)="updateActualStartDate($event)"
                dateFormat="mm/dd/yy"
                [disabledDays]="[0, 6]"
                placeholder="Select start date"
                [disabled]="selectedTask().isLotOnHold"
              >
              </p-datepicker>
              @if (startDateError()) {
                <div class="text-danger small mt-1">{{ startDateError() }}</div>
              }
            </div>
            <div class="col-6">
              <label class="form-label" for="">End Date</label>
              <p-datepicker
                styleClass="w-100"
                [iconDisplay]="'input'"
                [showIcon]="true"
                [ngModel]="actualEndDate()"
                (ngModelChange)="updateActualEndDate($event)"
                dateFormat="mm/dd/yy"
                [disabledDays]="[0, 6]"
                [disabled]="!actualStartDate() || selectedTask().isLotOnHold"
                [minDate]="actualStartDate()"
                placeholder="Select end date"
              >
              </p-datepicker>
              @if (endDateError()) {
                <div class="text-danger small mt-1">{{ endDateError() }}</div>
              }
            </div>
          </div>
        }
      </div>
    </div>
    <hr />
    @if (selectedTask().exceptionReason) {
      <h6 class="d-block fw-600 mb-2">Exception Reason</h6>
      <div class="alert alert-warning mb-3">
        {{ selectedTask().exceptionReason }}
      </div>
    }

    @if (ability.can('update-schedule-lots-tasks', 'schedule-lots')) {
      <button
        class="align-items-center btn btn-white border btn-h42 d-flex fs-16 gap-3 rounded-2 w-100 mb-2"
        [ngClass]="{
          'btn-success': selectedTask().status === TaskStatusEnum.COMPLETED
        }"
        (click)="markAsCompleted()"
        [disabled]="selectedTask().isLotOnHold"
      >
        <i class="bi bi-check fs-24 lh-1"></i>Mark as Completed
      </button>

      <button
        class="align-items-center btn btn-white border btn-h42 d-flex fs-16 gap-3 rounded-2 w-100 mb-2"
        [ngClass]="{
          'btn-warning': selectedTask().status === TaskStatusEnum.COMPLETED_WITH_EXCEPTION
        }"
        (click)="toggleExceptionInput()"
        [disabled]="selectedTask().isLotOnHold"
      >
        <i class="bi bi-exclamation-triangle lh-1"></i>Complete with Exception
      </button>

      @if (showExceptionInput()) {
        <div class="mb-3">
          <label class="form-label">Exception Reason: </label>
          <textarea
            class="form-control rounded-2 mb-2"
            rows="3"
            placeholder="Enter the exception reason"
            [ngModel]="exceptionReason()"
            (ngModelChange)="updateExceptionReason($event)"
            [disabled]="selectedTask().isLotOnHold"
          >
          </textarea>
          @if (exceptionReasonError()) {
            <div class="text-danger small mb-2">{{ exceptionReasonError() }}</div>
          }
          <div class="d-flex justify-content-end gap-2 mb-3">
            <button class="btn btn-secondary btn-h42" (click)="toggleExceptionInput()">Cancel</button>
            <button class="btn btn-primary btn-h42" (click)="submitException()">Submit</button>
          </div>
        </div>
      }

      <button
        class="align-items-center btn btn-white border btn-h42 d-flex fs-16 gap-3 rounded-2 w-100 mb-2"
        [ngClass]="{
          'btn-secondary': selectedTask().status === TaskStatusEnum.SKIP
        }"
        (click)="skipTask()"
        [disabled]="
          selectedTask().isLotOnHold ||
          selectedTask().status === TaskStatusEnum.COMPLETED ||
          selectedTask().status === TaskStatusEnum.COMPLETED_WITH_EXCEPTION
        "
      >
        <i
          class="bi"
          [ngClass]="{
            'bi-x fs-24': selectedTask().status !== TaskStatusEnum.SKIP,
            'bi-arrow-return-left': selectedTask().status === TaskStatusEnum.SKIP
          }"
        ></i>
        {{ selectedTask().status === TaskStatusEnum.SKIP ? 'Un-skip' : 'Skip' }} Task
      </button>

      <hr />

      <button
        class="align-items-center btn btn-white border btn-h42 d-flex fs-16 gap-3 rounded-2 w-100 mb-2"
        (click)="startToday()"
        [disabled]="selectedTask().isLotOnHold"
      >
        <i class="bi bi-play-circle lh-1"></i>Start Today
      </button>

      <button
        class="align-items-center btn btn-white border btn-h42 d-flex fs-16 gap-3 rounded-2 w-100 mb-2"
        (click)="unstartTask()"
        [disabled]="selectedTask().isLotOnHold || isUnstartDisabled()"
      >
        <i class="bi bi-arrow-return-left lh-1"></i>Unstart Task
      </button>

      <button
        class="align-items-center btn btn-white border btn-h42 d-flex fs-16 gap-3 rounded-2 w-100"
        (click)="holdTask()"
        [disabled]="
          (selectedTask().isLotOnHold && !selectedTask().isOnHold) ||
          selectedTask().status === TaskStatusEnum.COMPLETED ||
          selectedTask().status === TaskStatusEnum.COMPLETED_WITH_EXCEPTION
        "
      >
        <i class="bi bi-pause-circle lh-1"></i>
        {{ selectedTask().isOnHold === true ? 'Unhold' : 'Hold' }} Task
      </button>

      @if (selectedTask().isLotOnHold) {
        <hr />
        <div class="alert alert-warning py-2 px-3 mt-3 d-flex align-items-center gap-2">
          <i class="bi bi-exclamation-triangle-fill text-warning"></i>
          <span class="fs-14 fw-500">A task in this lot is currently on hold. Actions may be restricted.</span>
        </div>
      }
    }
  </div>
</div>
